import { render, staticRenderFns } from "./tiedCardResult.vue?vue&type=template&id=e75cbe8c&scoped=true"
import script from "./tiedCardResult.vue?vue&type=script&lang=js"
export * from "./tiedCardResult.vue?vue&type=script&lang=js"
import style0 from "./tiedCardResult.vue?vue&type=style&index=0&id=e75cbe8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75cbe8c",
  null
  
)

export default component.exports